import React, { FC } from 'react';

const DownloadIcon: FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C8.27614 0 8.5 0.223858 8.5 0.5V11.5C8.5 11.7761 8.27614 12 8 12C7.72386 12 7.5 11.7761 7.5 11.5V0.5C7.5 0.223858 7.72386 0 8 0Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.65 6.14645C2.84526 5.95118 3.15474 5.95118 3.35 6.14645L8 10.7929L12.65 6.14645C12.8453 5.95118 13.1547 5.95118 13.35 6.14645C13.5453 6.34171 13.5453 6.65829 13.35 6.85355L8.35 11.8536C8.15474 12.0488 7.84526 12.0488 7.65 11.8536L2.65 6.85355C2.45474 6.65829 2.45474 6.34171 2.65 6.14645Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 11C0.776142 11 1 11.2239 1 11.5V15H15V11.5C15 11.2239 15.2239 11 15.5 11C15.7761 11 16 11.2239 16 11.5C16 11.7761 16 15.5 16 15.5C16 15.7761 15.7761 16 15.5 16H0.5C0.223858 16 0 15.7761 0 15.5V11.5C0 11.2239 0.223858 11 0.5 11Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DownloadIcon;
